interface ProductFiltersProps {
  category: string;
  onCategoryChange: (value: string) => void;
  sort: string;
  onSortChange: (value: string) => void;
  minScore: number | undefined;
  onMinScoreChange: (value: number | undefined) => void;
  maxScore: number | undefined;
  onMaxScoreChange: (value: number | undefined) => void;
}

export function ProductFilters({
  category,
  onCategoryChange,
  sort,
  onSortChange,
  minScore,
  onMinScoreChange,
  maxScore,
  onMaxScoreChange,
}: ProductFiltersProps) {
  return (
    <div className="flex gap-3">
      <input
        type="text"
        value={category}
        onChange={(e) => onCategoryChange(e.target.value)}
        placeholder="Filter by category..."
        className="input max-w-xs"
      />
      <select
        value={sort}
        onChange={(e) => onSortChange(e.target.value)}
        className="input max-w-[200px]"
      >
        <option value="">Default order</option>
        <option value="score_asc">Score: Low to High</option>
        <option value="score_desc">Score: High to Low</option>
        <option value="title_asc">Title: A-Z</option>
        <option value="price_asc">Price: Low to High</option>
        <option value="price_desc">Price: High to Low</option>
      </select>
      <input
        type="number"
        value={minScore ?? ''}
        onChange={(e) => onMinScoreChange(e.target.value ? parseFloat(e.target.value) : undefined)}
        placeholder="Min score"
        min={1}
        max={5}
        step={0.5}
        className="input max-w-[120px]"
      />
      <input
        type="number"
        value={maxScore ?? ''}
        onChange={(e) => onMaxScoreChange(e.target.value ? parseFloat(e.target.value) : undefined)}
        placeholder="Max score"
        min={1}
        max={5}
        step={0.5}
        className="input max-w-[120px]"
      />
    </div>
  );
}
